import { TIMING_TYPE } from './AutoReplenishmentTimingTypes';

export enum TOGGLE_TYPE {
    CHECKBOX = 'checkbox',
    SWITCH = 'switch'
}

export enum INFO_POPUP_TRIGGER {
    ICON = 'icon',
    TEXT = 'text'
}

export const WEEK_DAYS = 7;
export const MONTH_DAYS = 30;

export const DAYS = {
    [TIMING_TYPE.DAYS]: 1,
    [TIMING_TYPE.WEEKS]: WEEK_DAYS,
    [TIMING_TYPE.MONTHS]: MONTH_DAYS
};

export const FREQUENCY_REGEX = /::FREQUENCY::/gi;
export const DAYS_REGEX = /::DAYS::/gi;
export const DAYS_PLACEHOLDER = '::days::';
